export class StudentQRCode {
    StudentName: string;
    ClassName: string;
    JoyToken: string;
}